module.exports = __webpack_public_path__ + "static/termitals-smthg.cc14d2447859f6258396be0bb2241559.png";